export class CompanyApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCompanies() {
    return this.#http.get('/api/companies');
  }

  async getCompany({ companyId, skipForbiddenError }) {
    return this.#http.get(`/api/companies/${companyId}`, {
      ...(skipForbiddenError && { skipResponseInterceptor: { forbiddenError: true } }),
    });
  }

  async createCompany(body) {
    return this.#http.post('/api/companies', body);
  }

  async editCompany(body) {
    return this.#http.put(`/api/companies/${body.companyId}`, body);
  }

  async deleteCompany({ companyId }) {
    return this.#http.delete(`/api/companies/${companyId}`);
  }

  async updateCompanyBranding({ companyId, branding }) {
    return this.#http.put(`/api/companies/${companyId}/branding`, branding);
  }

  async uploadCompanyImage({ companyId, type, formData }) {
    return this.#http.post(`/api/companies/${companyId}/images/${type}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}
